export const applyCpuFilter = (
    source: HTMLImageElement | HTMLCanvasElement,
    destinationContext: CanvasRenderingContext2D,
    width: number,
    height: number,
    filter: string
): void => {

    const image = destinationContext.getImageData(0, 0, width, height);
    const newData = new Uint8ClampedArray(image.data);

    if (filter === 'grayscale') {
        for (let i = 0; i < newData.length; i += 4) {
            const value = (newData[i] + newData[i + 1] + newData[i + 2]) / 3;
            newData[i] = value;
            newData[i + 1] = value;
            newData[i + 2] = value;
        }
    }

    image.data.set(newData);
    destinationContext.putImageData(image, 0, 0);
};